const e = {
  undo: "Anular",
  redo: "Refazer",
  confirm: "Confirmar",
  clear: "Limpar",
  more: "mais",
  cancel: "Cancelar",
  update: "Atualizar"
}, a = {
  positiveText: "Confirmar",
  negativeText: "Cancelar"
}, o = {
  placeholder: "Selecione",
  loading: "A carrregar"
}, r = {
  clear: "Limpar",
  now: "Agora",
  confirm: "Confirmar",
  selectTime: "Selecionar hora",
  selectDate: "Selecionar data",
  datePlaceholder: "Selecionar data",
  datetimePlaceholder: "Selecionar data e hora",
  monthPlaceholder: "Selecione mês",
  yearPlaceholder: "Selecione ano",
  quarterPlaceholder: "Selecione o Trimestre",
  startDatePlaceholder: "Data de início",
  endDatePlaceholder: "Data de fim",
  startDatetimePlaceholder: "Data e hora de início",
  endDatetimePlaceholder: "Data e hora de fim",
  startMonthPlaceholder: "Mês de Início",
  endMonthPlaceholder: "Fim do Mês",
  today: "Hoje"
}, i = {
  checkTableAll: "Selecione tudo na tabela",
  uncheckTableAll: "Desmarque tudo na tabela",
  confirm: "Confirmar",
  clear: "Limpar",
  apply: "Aplicar",
  filters: "Filtros",
  sort: "Ordenar"
}, t = {
  sourceTitle: "Fonte",
  targetTitle: "Destino"
}, n = {
  selectAll: "Selecionar tudo",
  unselectAll: "Desmarcar tudo",
  clearAll: "Limpar"
}, c = {
  description: "Sem dados"
}, l = {
  placeholder: "Selecione"
}, d = {
  placeholder: "Selecionar hora",
  positiveText: "OK",
  negativeText: "Cancelar",
  now: "Agora"
}, s = {
  goto: "Ir para",
  selectionSuffix: "página",
  next: "Seguinte",
  previous: "Anterior"
}, m = {
  add: "Adicionar"
}, p = {
  loading: "A carrregar"
}, g = {
  placeholder: "Introduza"
}, u = {
  placeholder: "Introduza"
}, h = {
  create: "Criar"
}, f = {
  title: "Editor de temas",
  clearAllVars: "Limpar todas as variáveis",
  clearSearch: "Limpar pesquisa",
  filterCompName: "Nome do componente de filtro",
  filterVarName: "Nome da variável de filtro",
  import: "Importar",
  export: "Exportar",
  restore: "Repor como predefinição"
}, C = {
  tipPrevious: "Imagem anterior (←)",
  tipNext: "Imagem seguinte (→)",
  tipCounterclockwise: "No sentido anti-horário",
  tipClockwise: "No sentido horário",
  tipZoomOut: "Reduzir o zoom",
  tipZoomIn: "Aumentar o zoom",
  tipClose: "Fechar (Esc)",
  tipOriginalSize: "Zoom para o tamanho original"
}, P = {
  heading: "Ordenar e filtros",
  sortHeading: "Ordenar por",
  newestFirst: "Mais recente primeiro",
  oldestFirst: "Mais antigo primeiro",
  ascending: "Asc",
  descending: "Desc",
  apply: "Aplicar",
  clear: "Limpar",
  cancel: "Cancelar",
  filters: "Filtros"
}, S = {
  noMatchingFound: "Não foram encontrados resultados correspondentes"
}, A = {
  margin: "Margem",
  padding: "Preenchimento",
  reset: "Repor",
  errorMsg: "O valor fornecido é inválido."
}, T = {
  brandColors: "Cores da marca",
  noBrandColors: "Ainda não tem nenhuma cor de marca adicionada.",
  getStarted: "Começar",
  add: "Adicionar",
  default: "Predefinição"
}, D = {
  addColor: "Adicionar Nova Cor",
  editColor: "Editar Cor",
  add: "Adicionar",
  noData: "Ainda não tem nenhuma cor adicionada.",
  invalidCode: "Código de cor inválido",
  defaultColor: "Cores predefinidas"
}, I = {
  global: e,
  Popconfirm: a,
  Cascader: o,
  DatePicker: r,
  DataTable: i,
  LegacyTransfer: t,
  Transfer: n,
  Empty: c,
  Select: l,
  TimePicker: d,
  Pagination: s,
  DynamicTags: m,
  Log: p,
  Input: g,
  InputNumber: u,
  DynamicInput: h,
  ThemeEditor: f,
  Image: C,
  SortFilter: P,
  IconPicker: S,
  Spacing: A,
  BrandColorPicker: T,
  BrandBoard: D
};
export {
  D as BrandBoard,
  T as BrandColorPicker,
  o as Cascader,
  i as DataTable,
  r as DatePicker,
  h as DynamicInput,
  m as DynamicTags,
  c as Empty,
  S as IconPicker,
  C as Image,
  g as Input,
  u as InputNumber,
  t as LegacyTransfer,
  p as Log,
  s as Pagination,
  a as Popconfirm,
  l as Select,
  P as SortFilter,
  A as Spacing,
  f as ThemeEditor,
  d as TimePicker,
  n as Transfer,
  I as default,
  e as global
};
